import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import ProductsPage from './pages/ProductsPage'
import OrdersPage from './pages/OrdersPage'
import StatisticsPage from './pages/StatisticsPage'
import VelocityAnalysisPage from './pages/VelocityAnalysisPage'
import StockTrackingPage from './pages/StockTrackingPage'
import UsersPage from './pages/UsersPage'
import BarcodeOrderControlPage from './pages/BarcodeOrderControlPage'
import LabelPrintPage from './pages/LabelPrintPage'
import ChatbotPage from './pages/ChatbotPage'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
    const { isAuthenticated } = useAuthStore()

    return (
        <Routes>
            {/* Public routes */}
            <Route
                path="/login"
                element={
                    isAuthenticated ? <Navigate to="/products" replace /> : <LoginPage />
                }
            />

            {/* Protected routes */}
            <Route path="/" element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                    <Route index element={<Navigate to="/products" replace />} />
                    <Route path="products" element={<ProductsPage />} />
                    <Route path="orders" element={<OrdersPage />} />
                    <Route path="statistics" element={<StatisticsPage />} />
                    <Route path="velocity" element={<VelocityAnalysisPage />} />
                    <Route path="stock-tracking" element={<StockTrackingPage />} />
                    <Route path="barcode-control" element={<BarcodeOrderControlPage />} />
                    <Route path="label-print" element={<LabelPrintPage />} />
                    <Route path="chatbot" element={<ChatbotPage />} />
                    <Route path="users" element={<UsersPage />} />
                </Route>
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/products" replace />} />
        </Routes>
    )
}

export default App
